import { CardBody as ChakraUICardBody, CardBodyProps } from '@chakra-ui/react';
import React, { FC, PropsWithChildren } from 'react';

type BodyProps = PropsWithChildren & CardBodyProps;

export const CardBody: FC<BodyProps> = ({ children, ...rest }) => {
  /**
   * DOM
   */
  return (
    <ChakraUICardBody {...rest} data-object-type="core-card-body">
      {children}
    </ChakraUICardBody>
  );
};
